import { FETCH_SPECS } from './constants'

export const fetchSpecs = {
  request: customerId => ({ type: FETCH_SPECS['REQUEST'], customerId }),
  success: specs => ({ type: FETCH_SPECS['SUCCESS'], specs })
}



// WEBPACK FOOTER //
// ./src/containers/Specs/actions.js